import { Proposal, RuleResultType } from "@cf247/pricing";

export default function sanitisedFailedReason(proposal: Proposal) {
    const reason = proposal.customerRuleResults?.find(r => r.resultType === RuleResultType.FixedDecline);
    if(reason && reason.message){
        if(reason.message.includes("score")){
            return `Customer does not meet credit score requirements`
        }
        if(reason.message.includes("bankruptcy") ||
            reason.message.includes("IVA") ||
            reason.message.includes("CCJ") ||
            reason.message.includes("default") ||
            reason.message.includes("arrears"))
            {
            return `Customer does not meet credit account requirements`
        }
        if(reason.message.includes("Dealer is banned")){
            return ''
        }
        return reason.message
    }
    return "";
}